import { IAccountBaseWithId } from './account.type'
import { IBaseDtoType } from './common.type'
import { IImpactTypeBaseWithId } from './impact-type.type'
import { IImpactPeriodBaseWithId } from './impact-period.type'
import { IImpactLibraryBaseWithId } from './impacts-library.type'
import { IImpactBaseWithId } from './impacts.type'
import { IJourneyBaseWithId } from './journey.type'
import { IProductBaseWithId } from './product.type'
import { IQuantityTypeBaseWithId } from './quantity-type.type'
import { IStepBaseWithId } from './step.type'
import { IUnSdgBaseWithId } from './un-sdg.type'
import { IProfileUserBaseWithId } from './user.type'
import { IScanRespDto } from './scan.type'
import { IMedia } from './media.type'
import { IRedirectURLRespDto } from './redirect-url.type'
import { IWhiteLabelBaseWithId } from './white-label-partners.type'
import { IConsumerScanBaseWithId } from './scan-to-earn.type'
import { IChallengesBaseWithId } from './challenges.type'
import { IDeclineReasonsBaseWithId } from './decline-reasons.type'
import { IRewardPointsBaseWithId } from './reward-points.type'
import { IApprovalFeedbacksBaseWithId } from './approval-feedbacks.type'

export interface IChange extends IBaseDtoType {
  user_name: string | null
  user_name_hidden: string | null
  user_email: string
}

export enum EChangeType {
  create = 'create',
  update = 'update',
  delete = 'delete',
}

export enum EChangeRelationType {
  account = 'account',
  product = 'product',
  journey = 'journey',
  step = 'step',
  impact = 'impact',
  library_impact = 'library_impact',
  quantity_type = 'quantity_type',
  un_sdg = 'un_sdg',
  impact_type = 'impact_type',
  impact_period = 'impact_period',
  user = 'user',
  scan = 'scan',
  media = 'media',
  redirect_url = 'redirect_url',
  white_label_partners = 'white_label_partners',
  twitter_bot = 'twitter_bot',
  cron_job = 'cron_job',
  vector_store = 'vector_store',
  web_chat_bot = 'web_chatbot',
  consumer_scan = 'consumer_scan',
  challenge = 'challenge',
  decline_reason = 'decline_reason',
  reward_point = 'reward_point',
  approval_feedback = 'approval_feedback',
}

export type ChangeRelationTypeKeys = keyof typeof EChangeRelationType

export interface IChangeDto extends IChange, IChangeDtoRelationsWithAccount {
  before: string | null
  after: string | null
  type: EChangeType
  relation_type: ChangeRelationTypeKeys
}

export interface IChangesRespDto {
  data: IChangeDto[]
  count: number
}

type IChangeDtoRelationsWithAccount = {
  [K in ChangeRelationTypeKeys]: ChangeDtoRelationsWithAccountType<K>
}

type ChangeDtoRelationsWithAccountType<K extends ChangeRelationTypeKeys> =
  | (IChangeDtoRelationsWithAccountMap[K] & { account: IAccountBaseWithId })
  | null

interface IChangeDtoRelationsWithAccountMap {
  account: IAccountBaseWithId
  product: IProductBaseWithId
  journey: IJourneyBaseWithId
  step: IStepBaseWithId
  impact: IImpactBaseWithId
  library_impact: IImpactLibraryBaseWithId
  quantity_type: IQuantityTypeBaseWithId
  un_sdg: IUnSdgBaseWithId
  impact_type: IImpactTypeBaseWithId
  impact_period: IImpactPeriodBaseWithId
  user: IProfileUserBaseWithId
  scan: IScanRespDto
  media: IMedia
  redirect_url: IRedirectURLRespDto
  white_label_partners: IWhiteLabelBaseWithId
  twitter_bot: any
  cron_job: any
  web_chat_bot: any
  consumer_scan: IConsumerScanBaseWithId
  challenge: IChallengesBaseWithId
  decline_reason: IDeclineReasonsBaseWithId
  reward_point: IRewardPointsBaseWithId
  approval_feedback: IApprovalFeedbacksBaseWithId
  vector_store: any
}
